<template>
    <div>
      <b-container class="h-100">
        <b-row class="match-height">
          <b-col md="6" v-for="(reportType, index) in reportTypes" :key="index" class="h-100">
            <router-link :to="reportType.route" class="cursor-pointer">
              <StatisticCardHorizontal
                :iconComponent="reportType.iconComponent"
                :statistic="reportType.title"
                :color="reportType.color"
                class="square-card"
                width="50"
                :colorHex="reportType.colorHex"
              />
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  
  <script>
  import { BContainer, BRow, BCol } from "bootstrap-vue";
  import StatisticCardHorizontal from "./StatisticCardHorizontal.vue";
   import { RouterLink } from "vue-router";
  import SalesReportIcon from "./SalesReportIcon.vue";
  import InventoryReportIcon from "./InventoryReportIcon.vue";
  import ProductionReportIcon from "./ProductionReportIcon.vue";
  import MarketingReportIcon from "./MarketingReportIcon.vue";
  import AccountingReportIconVue from "./AccountingReportIcon.vue";
  import TdsIcon from "./TdsIcon.vue";
  import CashBookIcon from "./CashBookIcon.vue";
  export default {
    components: {
      BContainer,
      BRow,
      BCol,
      StatisticCardHorizontal,
      SalesReportIcon,
      InventoryReportIcon,ProductionReportIcon,MarketingReportIcon,AccountingReportIconVue,TdsIcon, CashBookIcon
    },
    data() {
      return {
        reportTypes: [
          {
            title: "Trial Balance",
            route: "/reports/accounting/trial",
            color: "danger",
            iconComponent: SalesReportIcon,
            colorHex:"#d22828"
          },
          {
            title: "Balance sheet",
            route: "/reports/accounting/balancesheet",
            color: "info",
            iconComponent: InventoryReportIcon,
            colorHex:"#4272b6"
          },
          {
            title: "Profit & Loss",
            route: "/reports/accounting/pnl",
            color: "success",
            iconComponent: ProductionReportIcon,
            colorHex:"#f9e037"
          },
          {
            title: "TDS",
            route: "/reports/accounting/tds",
            color: "danger",
            iconComponent: TdsIcon,
            colorHex:"#48a154"
          },
          {
            title: "Cash Book",
            route: "/reports/accounting/cashbook",
            color: "success",
            iconComponent: CashBookIcon,
            colorHex:"#b5cf53"
          },
          {
            title: "VAT Report",
            route: "/reports/accounting/VATReturn",
            color: "danger",
            iconComponent: TdsIcon,
            colorHex:"#4272b6"
          },
          {
            title: "General Ledger",
            route: "/reports/accounting/GeneralLedger",
            color: "danger",
            iconComponent: TdsIcon,
            colorHex:"#d22828"
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped></style>
  